/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */

export type InternalDepartment = typeof InternalDepartment[keyof typeof InternalDepartment];


export const InternalDepartment = {
  Development: 'Development',
  Sales: 'Sales',
  Marketing: 'Marketing',
  CustomerSuccess: 'CustomerSuccess',
  Finance: 'Finance',
} as const;
